import { render } from "./WidgetsList.vue?vue&type=template&id=4e82cc78"
import script from "./WidgetsList.vue?vue&type=script&lang=js"
export * from "./WidgetsList.vue?vue&type=script&lang=js"

import "./WidgetsList.vue?vue&type=style&index=0&id=4e82cc78&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__